import { auth, uid as uidFunc } from "@/common/helpers/firebase"
import { toData } from "@/common/helpers/toData"
import { UserPublicProfile } from "@/common/helpers/userPublicProfile"
import { FSUserPublicProfile } from "@WombatTechnology/nitte-time-lib"
import { defineStore } from "pinia"

const CALENDAR_TYPE_STORAGE_KEY = 'nitte-text-receive-calendar-type'

export type State = {
  userPublicProfile: FSUserPublicProfile | null
}

export const useUserStore = defineStore("user", {
  state: (): State => {
    return {
      userPublicProfile: null,
    }
  },
  actions: {
    async setup() {
      const uid = uidFunc()!
      const doc = UserPublicProfile.doc(uid)
      const userPublicProfile = await toData(doc)
      this.userPublicProfile = userPublicProfile

      if (userPublicProfile?.accountType === "ms") {
        localStorage.setItem(CALENDAR_TYPE_STORAGE_KEY, 'outlook')
      } else if (userPublicProfile) {
        localStorage.setItem(CALENDAR_TYPE_STORAGE_KEY, 'google')
      }

      this.sync("userPublicProfile", doc)
    },
  },
  getters: {
    isLoggedIn(state): boolean {
      return !!state.userPublicProfile
    },
    userIcon(state) {
      return state.userPublicProfile?.icon || auth.currentUser?.photoURL || null
    },
    isCalendarScopeAuthorized(state): boolean {
      return UserPublicProfile.isCalendarScopeAuthorized(state.userPublicProfile)
    },
  },
})
